<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="currentPage"
    :page-sizes="[10, 20, 50, 100]"
    :page-size="value.limit"
    layout="total, sizes, prev, pager, next, jumper"
    :total="value.total">
  </el-pagination>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  data() {
    return {};
  },

  computed: {
    currentPage() {
      return this.value.start / this.value.limit + 1;
    }
  },

  methods: {
    handleSizeChange(x) {
      if (x !== this.value.limit) {
        this.$emit("input", {
          ...this.value,
          limit: x,
          start: 0
        });
      }
    },
    handleCurrentChange(x) {
      const start = (x - 1) * this.value.limit;
      if (!isNaN(start) && start !== this.value.start) {
        this.$emit("input", {
          ...this.value,
          start
        });
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/common/simplePagination.vue